import React, {Component} from 'react';
import {withRouter, Link} from 'react-router-dom';
import {observer, inject} from 'mobx-react';
import {getFindables, getFindable} from '../../../sources/Findables';
import {pluralize} from '../../../lib/Helpers';

import TrayContainerWithHeader from '../../shared/TrayContainerWithHeader';

@inject('mapStore', 'routing')
@withRouter
@observer
class Find extends Component {
  componentWillMount() {
    getFindables().then((response) => {
      this.props.mapStore.findables.replace(response.data);
    });
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.getHighlightedFeature(this.props.match.params.id);
    }
  }

  getHighlightedFeature(feature_slug) {
    getFindable({slug: feature_slug}).then((response) => {
      this.props.mapStore.trayContainerClass = 'is-flexible';
      const visible = this.props.mapStore.allFloorsData.filter((entity) => entity.visible);
      const features = visible.filter((room) => response.data.types.indexOf(room.type) !== -1);
      const featureIds = features.map((feature) => feature.id);
      const floors = [... new Set(features.map(feature => feature.level))].sort();   // creates a unique list by destructuring a Set
//	  if(floors.length > 0) {
        this.props.mapStore.highlightedFeature = {
          title: response.data.title,
          attribute: 'id',
          value: featureIds,
          floors: floors
        };
//	  }
    });
  }


  getLinkForItem(item, i) {
    if (item.external && item.url) {
      return <a key={i} href={item.url} data-findable={item.slug}>
        <span>{item.title}</span>
      </a>
    } else {
      return <Link key={i} to={`/find/${item.slug}`} data-findable={item.slug}>
        <span>{item.title}</span>
      </Link>
    }

  }

  render() {
    const key = `find-tray-container-floor-${this.props.mapStore.floor}`;
    if (this.props.match.params.id && this.props.mapStore.highlightedFeature && !this.props.mapStore.highlightId) {
      return (
        <TrayContainerWithHeader title="Showing" trayClass="find-detail" currentItem={this.props.mapStore.currentItem} mapStore={this.props.mapStore} params={this.props.match.params} key={key}>

          <div className="title">{this.props.mapStore.highlightedFeature.title}</div>

        </TrayContainerWithHeader>
      )
    } else if (this.props.match.params.id && !this.props.mapStore.highlightedFeature) {
      // loading state
      return <React.Fragment></React.Fragment>
    } else if (this.props.match.params.id && this.props.mapStore.highlightId) {
      return (
        <TrayContainerWithHeader title="Showing" trayClass="find-detail" currentItem={this.props.mapStore.currentItem} mapStore={this.props.mapStore} params={this.props.match.params} key={key}>
          {this.props.mapStore.highlightedFeature.title}
          <div>
            {this.props.mapStore.currentHighlightItem.description}
          </div>
        </TrayContainerWithHeader>
      )
    } else {
      const items = <ul className="m-secondary-menu">
        {this.props.mapStore.findables.map((item, i) => {
          return (
            <li key={i}>
              {this.getLinkForItem(item, i)}
            </li>
          )
        })}
      </ul>

      return (
        <TrayContainerWithHeader title="Find" trayClass="find" params={this.props.match.params} key={key}>

          {items}

        </TrayContainerWithHeader>
      )
    }
  }
}

export default Find;
